<template>
  <div
    v-bind:class="{
      largePrimaryButton: true,
      largePrimaryButtonFlat: !!flat,
      largePrimaryButtonRounded: !flat,
      bottomActionButton: !!bottomActionButton,
      largePrimaryButtonActive: active,
    }"
    v-on:click="onClick"
  >
    {{text}}
  </div>
</template>

<script>

  export default {
    name: 'LargePrimaryButton',
    props: ['text', 'flat', 'bottomActionButton', 'active'],
    data() {
      return {
      }
    },
    methods: {

      onClick: function () {
        if (this.active) {
          this.$emit('click');
        }
      }

    },

    created() {
    }
  }
</script>

<style lang="scss">
@import "src/assets/scss/variables";

  .largePrimaryButton {
    text-align: center;
    padding: $primaryPadding;
    font-size: $primaryButtonFontSize;
    line-height: $primaryButtonLineHeight;
    font-weight: 600;
    background: rgba(118, 118, 128, 0.5);
    color: #fff;
  }

  .largePrimaryButtonActive {
    background:  #2192F0;
    color: #fff;
  }


  @supports(padding:max(0px)) {
    .textInputAreaWrapper .bottomActionButton {
      padding-bottom: $bigPadding !important;
    }
  }

  .textInputAreaWrapper:focus-within .largePrimaryButton {
    padding-bottom: $primaryPadding !important;
  }

  .largePrimaryButton:active {
    opacity: 0.7;
  }

  .largePrimaryButtonRounded {
    border-radius: 12px;
  }

</style>
